module.exports = global["angular"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?angular!../node_modules/angular/index.js-exposed
// module id = 257
// module chunks = 3